module.exports = __webpack_public_path__ + "static/assets/e02278ade9b69850f9112f0f039a113b.png";